import { Routes } from '@angular/router';
import { CheckoutGaCategory } from '@checkout/util-models';
import { CmsPageComponent, cmsPageTemplateResolver } from '@domgen/dgx-fe-cms';

export const DIRECT_DEBIT_ROUTES: Routes = [
  {
    path: '',
    component: CmsPageComponent,
    data: {
      gaData: {
        category: CheckoutGaCategory.Pages,
      },
    },
    resolve: {
      cmsPageTemplate: cmsPageTemplateResolver,
    },
  },
];
